import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { ADOPERATIONS, ROUTES } from "@constants/index";
import { AccountService } from "@services";
import { datadogLogs } from "@datadog/browser-logs";
import utils from "@utils";
import PropTypes from "prop-types";
import { SplashScreen } from "../../../../components";

const ADCallback = ({ router }) => {
	const { instance } = useMsal();

	const setActiveAccount = account => {
		localStorage.setItem("homeAccountId", account.homeAccountId);
	};

	const ensureAuthorize = () => {
		AccountService.me()
			.catch(error => {
				// Reset the `homeAccountId` if the API returns
				// unauthorized
				if (error?.response?.status === 401) {
					localStorage.removeItem("homeAccountId");
				}

				if (error?.response?.data?.Message) {
					const { lang } = global;
					utils.notify({
						type: "error",
						title: lang.t("Access Denied"),
						message: error?.response?.data?.Message,
					});
				}
			})
			.finally(() => router.push(ROUTES.root));
	};

	const callback = () => {
		const { lang } = global;

		instance
			.handleRedirectPromise()
			.then(accessTokenResponse => {
				if (accessTokenResponse) {
					switch (utils.decodeADState(accessTokenResponse.state).operation) {
						case ADOPERATIONS.changePassword:
							setActiveAccount(accessTokenResponse.account);
							utils.notify({
								type: "success",
								message: lang.t("Password successfully reset"),
								timeOut: 1500,
							});
							router.push(ROUTES.myAccount);
							break;

						case ADOPERATIONS.editMfa:
							setActiveAccount(accessTokenResponse.account);
							utils.notify({
								type: "success",
								message: lang.t("Adb2c Edit Mfa Message Success"),
								timeOut: 1500,
							});
							router.push(ROUTES.myAccount);
							break;

						case ADOPERATIONS.disableMfa:
							setActiveAccount(accessTokenResponse.account);
							utils.notify({
								type: "success",
								message: lang.t("Adb2c Disable Mfa Message Success"),
								timeOut: 1500,
							});
							router.push(ROUTES.myAccount);
							break;

						case ADOPERATIONS.changeEmail:
							setActiveAccount(accessTokenResponse.account);
							utils.notify({
								type: "success",
								message: lang.t("Adb2c Change Email Message Success"),
								timeOut: 1500,
							});
							router.push(ROUTES.myAccount);
							break;

						case ADOPERATIONS.login:
							setActiveAccount(accessTokenResponse.account);
							ensureAuthorize();

							break;

						case ADOPERATIONS.signup:
							router.push(ROUTES.signupConfirmation);
							break;

						case ADOPERATIONS.resetPassword:
							setActiveAccount(accessTokenResponse.account);
							ensureAuthorize();
							router.push(ROUTES.root);
							break;

						default:
							setActiveAccount(accessTokenResponse.account);
							router.push(ROUTES.root);
							break;
					}
				}
			})
			.catch(error => {
				if (!utils.isADCancellation(error)) {
					datadogLogs.logger.error(error.message);

					utils.notify({
						type: "error",
						message: lang.t("Something went wrong with the authentication system"),
						timeOut: 1500,
					});
				}
				router.push(ROUTES.root);
			});
	};

	useEffect(() => {
		callback();
	}, []);

	return (
		<div id="ad-signup">
			<SplashScreen />
		</div>
	);
};

ADCallback.propTypes = {
	router: PropTypes.object.isRequired,
};

export default ADCallback;
